import React, { useContext, useCallback } from 'react'
import { Dropdown, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import styles from './CompanyInfo.module.css'
import * as settings from '../../../../settings'
import * as facebookReq from '../../../../axios/requests/facebookReq'
import * as googleReq from '../../../../axios/requests/googleReq'
import FacebookLogin from 'react-facebook-login';
// import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
import AlertContext from '../../../../context/AlertModelContext/AlertModalContext';
import GoogleSignInButton from '../../../UI/GoogleSignInButton/GoogleSignInButton';

const rejectCompanyKeys = ['crmOnOpenContactWindowSendApiReq', 'pbxType']

const CompanyInfo = (props) => {
    const [t] = useTranslation('common')
    const alertCtx = useContext(AlertContext)
    const appAccess = props.appAccess
    let companyDetailsElements = undefined
    const onFacebookCallBack = async (event) => {
        if (event.userID && event.accessToken && event.data_access_expiration_time) {
            facebookReq.onFacebookUserLogin(event)
            props.onFaceBookUserIdChange(event.userID)
        }
    }

    const onFacebookLogoutBtnClicked = () => {
        if (props.facebook_userID) {
            facebookReq.onFacebookUserLogout(props.facebook_userID)
            window.FB.logout()
            props.onFaceBookUserIdChange()
        }

    }

    const handleOnGoogleSuccessfulLogin = useCallback(async (codeRes) => {
        try {
            const reqBody = {
                code: codeRes.code
            }
            await googleReq.googleLogin(reqBody)
            alertCtx.showAlert(t('success'), t('Successful login'), 'sm')
        } catch (e) {
            alertCtx.showAlert(t('fail'), t('Error to login google'), 'sm')
        }

    }, [alertCtx, t])


    const googleLogin = useGoogleLogin({
        flow: 'auth-code',
        scope: settings.googleAuthScopes,
        onSuccess: handleOnGoogleSuccessfulLogin,
        onError: errorResponse => {
            console.log(errorResponse)
            alertCtx.showAlert(t('fail'), t('Error to login google'), 'sm')
        },
    });

    if (props.companyDetails && props.companyDetails.length !== {}) {
        let companyDetailsKeys = Object.keys(props.companyDetails)
        companyDetailsKeys = companyDetailsKeys.filter(key => !rejectCompanyKeys.some(rejectKey => rejectKey === key))
        companyDetailsElements = companyDetailsKeys.map(companyDetailKey => {
            if (typeof props.companyDetails[companyDetailKey] !== 'object') {
                let detailValue = props.companyDetails[companyDetailKey]
                let toShow = true
                if (companyDetailKey === 'whatsapp') {
                    detailValue = detailValue.replace('whatsapp:', '').replace('+', '')
                }
                if (companyDetailKey === 'appAccess') {
                    detailValue = t(detailValue)
                }
                else if (companyDetailKey === 'sms') {
                    detailValue = detailValue.replace('+', '')
                }
                else if (companyDetailKey === 'BWAdminAuthUser') {
                    detailValue = detailValue.split('@')[0]
                    if (props.permissionType > 3) {
                        toShow = false
                    }
                }
                else if (companyDetailKey === 'crmUrl' || companyDetailKey === 'biUrl') {
                    detailValue = <a style={{ "textDecoration": "underline" }} target="_blank" rel="noopener noreferrer" href={detailValue}>{t('Click here')}</a>
                    if (props.permissionType > 3) {
                        toShow = false
                    }
                }
                else if (companyDetailKey === 'maxAgents') {
                    if (props.permissionType > 3) {
                        toShow = false
                    }
                }

                if (detailValue === undefined) {
                    detailValue = ''
                }
                if (!toShow) {
                    return undefined
                }

                return <div key={companyDetailKey} className={styles.companyProperty}>
                    <p className={styles.rectP}>
                        <span className={styles.fieldNameSpan}>- {t(companyDetailKey)}:</span>
                        <span className={styles.fieldValueSpan}>{detailValue}</span>
                    </p>
                </div>
            }
            else if (appAccess !== 'DIALER' && props.companyDetails[companyDetailKey] && companyDetailKey === 'facebook') {
                let pageAccessElements = undefined
                if (props.companyDetails.facebook.pageAccess && props.companyDetails.facebook.pageAccess.length > 0) {
                    pageAccessElements = props.companyDetails.facebook.pageAccess.map((pageAccessItem, index) => (
                        <div key={"" + pageAccessItem.pageId} className={styles.facebookPageDet}>
                            <span className={styles.subFieldElement}>
                                <span className={styles.fieldNameSpan}>{index + 1}. {t('Page name')} :</span>
                                <span className={styles.fieldValueSpan}>{pageAccessItem.pageName}</span>
                            </span>
                            <span className={styles.subFieldElement}>
                                <span className={styles.fieldNameSpan}>{t('Page id')} :</span>
                                <span className={styles.fieldValueSpan}>{pageAccessItem.pageId}</span>
                            </span>
                            {pageAccessItem.instagramId &&
                                <span className={styles.subFieldElement}>
                                    <span className={styles.fieldNameSpan}>{t('Instagram id')} :</span>
                                    <span className={styles.fieldValueSpan}>{pageAccessItem.instagramId}</span>
                                </span>
                            }
                        </div>

                    ))
                }
                return <div key={companyDetailKey} className={styles.companyProperty}>
                    <p className={styles.fieldRow}>
                        <span className={styles.fieldNameSpan}>- {t(companyDetailKey)}:</span>

                        <br />
                        <span className={`${styles.subFieldsElement}`}>
                            <br />
                            {pageAccessElements}

                            {
                                appAccess !== 'DIALER' && props.permissionType <= 2 &&
                                <div className={`${styles.companyProperty} ${styles['facebook-btn-container']}`}>
                                    <FacebookLogin
                                        appId={process.env.NODE_ENV === 'production' ? settings.facebookAppId_prod : settings.facebookAppId_dev}
                                        autoLoad={false}
                                        fields="name,email,picture"
                                        callback={onFacebookCallBack}
                                        version='19.0'
                                        cssClass='facebook_btn'
                                        scope={settings.FacebookLogin_scope}
                                    />
                                    {props.facebook_userID && <Button variant="danger" onClick={onFacebookLogoutBtnClicked} className='facebookLogOutDiv'>Logout</Button>}
                                </div>
                            }
                            {
                                appAccess !== 'DIALER' && props.permissionType <= 2 &&
                                <GoogleSignInButton onClick={googleLogin} />
                            }
                        </span>

                    </p>
                </div >
                // if(props.companyDetails[companyDetailKey].pageAccess)
            }
            else return undefined
        })
    }
    if (props.listOfOnlineAgents && companyDetailsElements && props.permissionType < 4) {
        companyDetailsElements.splice(2, 0, (
            <div key='onlineAgents' className={styles.companyProperty}>
                <p className={styles.rectP} >
                    <span className={styles.fieldNameSpan}>- {t('onlineAgents')}:</span>
                    <span style={{ "color": "#28a745", "fontWeight": "600" }} className={styles.fieldValueSpan}>{props.listOfOnlineAgents.length}</span>
                </p>
            </div>
        ));
    }
    if (props.device) {
        companyDetailsElements.splice(4, 0, (
            <div key='Extension' className={styles.companyProperty}>
                <p className={styles.rectP}>
                    <span className={styles.fieldNameSpan}>- {t('Extension')}:</span>
                    <span className={styles.fieldValueSpan}>{props.device}</span>
                </p>
            </div>
        ));
    }
    if (typeof props.companyAgents === 'object' && props.permissionType < 4) {
        companyDetailsElements.splice(3, 0, (
            <div key='Registered users' className={styles.companyProperty}>
                <p className={styles.rectP}>
                    <span className={styles.fieldNameSpan}>- {t('Registered users')}:</span>
                    <span className={styles.fieldValueSpan}>{props.companyAgents.length}</span>
                </p>
            </div>
        ));
    }
    return (
        <Dropdown
            drop='left'

        >
            <Dropdown.Toggle className={styles.dropDownBtn} id="dropdown-basic">
                {t('Company info')}
            </Dropdown.Toggle>

            <Dropdown.Menu className={styles.dropDownMenu}>
                <h4 className={styles.companyDetailsTitle}>{t('Company info')}</h4>
                {companyDetailsElements}

            </Dropdown.Menu>
        </Dropdown>
    )
}

export default CompanyInfo